/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MessagesInputs */

const en_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

const es_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes`)
};

const fr_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

const de_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachrichten`)
};

const ja_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージ`)
};

const zh_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息`)
};

const ar_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرسائل`)
};

const id_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan`)
};

const it_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggi`)
};

const ru_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщения`)
};

const pt_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagens`)
};

const ko_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Nav_MessagesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_messages = /** @type {((inputs?: Nav_MessagesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MessagesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_messages(inputs)
	if (locale === "es") return es_nav_messages(inputs)
	if (locale === "fr") return fr_nav_messages(inputs)
	if (locale === "de") return de_nav_messages(inputs)
	if (locale === "ja") return ja_nav_messages(inputs)
	if (locale === "zh") return zh_nav_messages(inputs)
	if (locale === "ar") return ar_nav_messages(inputs)
	if (locale === "id") return id_nav_messages(inputs)
	if (locale === "it") return it_nav_messages(inputs)
	if (locale === "ru") return ru_nav_messages(inputs)
	if (locale === "pt") return pt_nav_messages(inputs)
	return ko_nav_messages(inputs)
});